<template>
    <tr :class="index % 2 === 0 ? 'row-odd' : 'row-even'">
        <td class="td-padding">
            <input
                :checked="checked"
                :disabled="isDisabledCb"
                class="check-bulk"
                type="checkbox"
                @change="$emit('checked', {value: document.id, checked: $event.target.checked})"
            >
        </td>
        <td class="td-padding">{{ document.date_issued }}</td>
        <td class="td-padding">{{ document.translated_full_document_type }}</td>
        <td class="td-padding m-w-170">{{ document.document_number }}</td>
        <td class="td-padding">{{ document.correction_document_number }}</td>
        <td class="td-padding text-right">{{ document.net_amount }}</td>
        <td class="td-padding text-right">{{ document.gross_amount }}</td>
        <td class="td-padding text-right">{{ document.for_settlement_net }}</td>
        <td class="td-padding text-right">{{ document.for_settlement_gross }}</td>
        <td class="text-right table-icons">
            <DocumentStatusLabel :document="document" :status="document.status"/>
            <TableIcon
                v-if="document.download_scan_route"
                :href="document.download_scan_route"
                :title="__('download_file')"
                icon="fa-paperclip"
                target="_blank"
            />
            <TableIcon
                v-if="document.download_pdf_route"
                :href="document.download_pdf_route"
                :title="__('download_file')"
                icon="fa-paperclip"
                target="_blank"
            />
            <TableIcon v-if="document.show_document_route" :href="document.show_document_route" :title="__('show')" icon="fa-eye"/>
            <TableIcon
                v-if="document.edit_document_route"
                :disabled="!isAllowUpdate"
                :href="document.edit_document_route"
                :title="isAllowUpdate ? __('edit') : allowUpdateMessage"
                icon="fa-pen"
            />
        </td>
    </tr>
</template>

<script>
import DocumentStatusLabel from "../../../DocumentStatusLabel";
import TableIcon from "../../../table/TableIcon";

export default {
    name: "ContractDocumentTableRow",
    components: {TableIcon, DocumentStatusLabel},
    props: {
        document: {
            type: Object,
            required: true,
        },
        checked: {
            type: Boolean,
            default: false,
        },
        index: {
            type: Number,
            required: true,
        },
        relatedDocumentTypes: {
            type: Array,
            required: true,
        },
    },
    computed: {
        allow() {
            return this.document.permissions;
        },
        allowUpdateMessage() {
            return this.allow.messages.update;
        },
        isAllowUpdate() {
            return this.allow.permissions.update;
        },
        isDisabledCb() {
            return !this.relatedDocumentTypes.includes(this.document.document_type);
        },
    },
};
</script>
